import Header from 'Components/Elements/Header/Header'
import Footer from 'Components/Elements/Footer/Footer'
import { useEffect } from 'react'

import StoreCountry from 'GlobalStores/Cores/County/StoreCountry'
import { observer } from 'mobx-react-lite'
import { BrowserRouter, Route, Routes, Navigate, useLocation } from 'react-router-dom'
import ModalHandleError from 'Components/Elements/ModalHandleError/ModalHandleError'
import { storeElement } from 'GlobalStores/StoreElement'

import { PathHelper } from 'GlobalStores/Cores/Helpers/PathHelper'
import SelectCountryPage from 'Components/Pages/SelectCountry/SelectCountryPage'
import LoginWrapper from 'Components/Pages/LoginWrapper'
import MixpanelRouteObserver from 'Services/Mixpanel/MixpanelRouteObserver'

import { useSizeWindow } from './../Helpers/GlobalHelpers'
import DynamicWidthObserver from './components/DynamicWidthObserver'
import useLanguageSync from './hooks/useLanguageSync'
import useBypassPath from './hooks/useBypassPath'
import useUserMenuPath from './hooks/useUserMenuPath'
import AuthRoutes from './routes/AuthRoutes'
import CheckoutRoutes from './routes/CheckoutRoutes'
import PublicRoutes from './routes/PublicRoutes'
import UserRoutes from './routes/UserRoutes'

const AppRouter = observer(({ tiny }) => {
    useLanguageSync()
    const bypassPath = useBypassPath()
    const userPath = useUserMenuPath()
    const { width } = useSizeWindow()

    if (tiny) {
        return (
            <BrowserRouter basename={`${PathHelper.BuildBasename('select-country')}`}>
                <Routes>
                    <Route path={'/'} element={<SelectCountryPage />} />
                    <Route path={'/:referralId'} element={<SelectCountryPage />} />
                </Routes>
            </BrowserRouter>
        )
    }

    return (
        <BrowserRouter basename={`${PathHelper.BuildBasename(StoreCountry.CountryLowerCase())}`}>
            <DynamicWidthObserver />
            <Header />
            <AppRoutes width={width} userPath={userPath} bypassPath={bypassPath} />
            <Footer />
            <TriggerAlwaysToTop />
            <MixpanelRouteObserver />
            <ModalHandleError
                open={storeElement.formatError.open}
                errorDetails={storeElement.formatError.errorDetails}
                closeOnly={storeElement.formatError.closeOnly}
                description={storeElement.formatError.description}
                reload={storeElement.formatError.reload}
                onClose={() => storeElement.SetFormatError(false)}
            />
        </BrowserRouter>
    )
})

const withLoginWrapper = component => <LoginWrapper>{component}</LoginWrapper>

const AppRoutes = ({ width, userPath, bypassPath }) => {
    const isCompactLayout = width <= 834

    return (
        <Routes>
            {AuthRoutes({ withLoginWrapper, bypassPath })}
            {CheckoutRoutes({ withLoginWrapper })}
            {PublicRoutes({ withLoginWrapper })}
            {UserRoutes({
                isCompactLayout,
                userPath,
                withLoginWrapper
            })}
            <Route path="*" element={<Navigate to={`../${StoreCountry.CountryLowerCase()}`} replace />} />
        </Routes>
    )
}

const TriggerAlwaysToTop = () => {
    const location = useLocation()

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [location.pathname])

    return <div></div>
}

export default AppRouter
